/**
 * A missed exercise comes back later in the same lesson
 * ([Architecture](../../../docs/ARCHITECTURE.md#answering-an-exercise),
 * [Lesson types](../../../docs/LESSON-TYPES.md), [D-162](../../../docs/DECISIONS.md#d-162)).
 *
 * The child has just been told the answer, warmly. Asking again straight away
 * tests whether they can read the feedback sheet; asking a few questions later
 * tests whether it stuck, which is the point. So it goes back in a few places
 * on, or at the end when the lesson is nearly over.
 *
 * **Once.** A second miss is left to the mistakes pool and to spaced
 * repetition, which bring it back on another day. Looping on one question until
 * a child gets it right turns a lesson into a wall.
 */
/** How many other questions come between a miss and its second chance. */
export const RETRY_GAP = 3;
/**
 * Exercises that are never asked twice in a lesson. A story is a whole scene
 * with its own checks, and replaying it for one wrong answer would be starting
 * the story over.
 */
export const NEVER_RETRIED = new Set(['story']);
/** Whether a missed exercise of this type comes back. */
export const retriable = (type) => !NEVER_RETRIED.has(type);
/**
 * The queue with the exercise at `index` asked once more, `gap` questions
 * later, or last when fewer than that are left.
 */
export function retryLater(queue, index, gap = RETRY_GAP) {
    const item = queue[index];
    if (item === undefined)
        return queue;
    const at = Math.min(index + 1 + gap, queue.length);
    return [...queue.slice(0, at), item, ...queue.slice(at)];
}
//# sourceMappingURL=retry.js.map